const ACTIONS = {
  CALL_API: 'call-api',
  SUCCESS: 'success',
  ERROR: 'error',
  SET_INITIAL_DATA: 'set-data',

  TEXT_CHANGE: 'text-change',
  TEXT_SET_ERRORS: 'text-set-errors',
  TEXT_REMOVE_ERRORS: 'text-remove-errors',

  DATE_CHANGE: 'date-change',
  DATE_SET_ERRORS: 'date-set-errors',
  DATE_REMOVE_ERRORS: 'date-remove-errors',

  CHECK_CHANGE: 'check-change',
  CHECK_TOGGLE_PARENT: 'check-toggle-parent',
  CHECK_SELECT_ALL: 'check-select-all',
  CHECK_CLEAR_ALL: 'check-clear-all',
  CHECK_SET_ERRORS: 'check-set-errors',
  CHECK_REMOVE_ERRORS: 'check-remove-errors',
};

function clearReportTypeInvalid(data) {
  const clearField = (field) =>
    field && {
      ...field,
      validation: { ...field.validation, isInvalid: false, errors: [] }
    };
  const patch = {};
  if (data.reportTypeChildren) patch.reportTypeChildren = clearField(data.reportTypeChildren);
  if (data.reportTypeOther) patch.reportTypeOther = clearField(data.reportTypeOther);
  if (data.reportTypeError) patch.reportTypeError = clearField(data.reportTypeError);
  return patch;
}

const formInfoReducer = (state, action) => {
  // //console.log("dispatch triggered", state, action);

  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading
      };
    }

    // ----- TEXT -----
    case ACTIONS.TEXT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false, // isInvalidFunc(path.validation.required, action.value)
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- DATES (startDate / endDate) -----
    case ACTIONS.DATE_CHANGE: {
      const path = state.data[action.name]; // "startDate" or "endDate"
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.DATE_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.DATE_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    case ACTIONS.CHECK_CHANGE: {
      const group = state.data[action.fieldName];
      const updated = group.checkBoxes.map((c) =>
        c.id === action.id ? { ...c, isChecked: action.checked } : c
      );
      return {
        ...state,
        data: {
          ...state.data,
          ...clearReportTypeInvalid(state.data),
          [action.fieldName]: {
            ...group,
            checkBoxes: updated,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_TOGGLE_PARENT: {
      const group = state.data[action.fieldName];
      const allChecked = group.checkBoxes.length > 0 && group.checkBoxes.every((c) => c.isChecked);
      const nextChecked = !allChecked;
      const updated = group.checkBoxes.map((c) => ({ ...c, isChecked: nextChecked }));
      return {
        ...state,
        data: {
          ...state.data,
          ...clearReportTypeInvalid(state.data),
          [action.fieldName]: {
            ...group,
            checkBoxes: updated,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_SELECT_ALL: {
      const group = state.data[action.fieldName];
      const updated = group.checkBoxes.map((c) => ({ ...c, isChecked: true }));
      return {
        ...state,
        data: {
          ...state.data,
          ...clearReportTypeInvalid(state.data),
          [action.fieldName]: {
            ...group,
            checkBoxes: updated,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_CLEAR_ALL: {
      const group = state.data[action.fieldName];
      const updated = group.checkBoxes.map((c) => ({ ...c, isChecked: false }));
      return {
        ...state,
        data: {
          ...state.data,
          ...clearReportTypeInvalid(state.data),
          [action.fieldName]: {
            ...group,
            checkBoxes: updated,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_SET_ERRORS: {
      const group = state.data[action.fieldName];
      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: {
            ...group,
            validation: {
              ...group.validation,
              isInvalid: action.isInvalid ?? (action.errors != null && action.errors.length > 0),
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_REMOVE_ERRORS: {
      const group = state.data[action.fieldName];
      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: {
            ...group,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- API submission -----
    case ACTIONS.CALL_API: {
      return {
        ...state,
        loading: true,
        apiError: null
      };
    }
    case ACTIONS.SUCCESS: {
      return {
        ...state,
        loading: false,
        apiError: null,
        apiResponse: action.response
      };
    }
    case ACTIONS.ERROR: {
      return {
        ...state,
        loading: false,
        apiError: action.error
      };
    }
  }
};

export { ACTIONS, formInfoReducer };
